import { useLocale } from './useLocale';
import { computed } from '@vue/composition-api';
import { IntentTypeInputConfig } from '../dataType';
import { useConfig } from './useConfig';

export const useIntentTypes = () => {
  const { t } = useLocale();
  const { getUserInfo } = useConfig();
  const { dataQueriesSwitch } = getUserInfo();
  const intentTypes = computed<IntentTypeInputConfig[]>(() => {
    return [{
      text: `${t('saas.robotChat.Intention.assistant')}`,
      type: 'knowledge_qa',
      icon: 'iconQAAssistant',
      defaultInput: 'saas.robotChat.intentDefault.QAAssistantDefaultInput',
      placeholder: t('saas.robotChat.intentDefault.QAAssistantPlaceholder'),
      describe: t('saas.robotChat.intentDefault.QAAssistantDescribe'),
      enabled: true
    }, {
      text: `${t('saas.robotChat.intent.report')}`,
      type: 'work_report',
      // eslint-disable-next-line spellcheck/spell-checker
      icon: 'iconbaogao',
      defaultInput: 'saas.robotChat.intentDefault.report',
      placeholder: t('saas.robotChat.intent.report.placeholder'),
      describe: t('saas.robotChat.intent.report.describe'),
      enabled: true
    },
    {
      text: `${t('saas.robotChat.intent.progress')}`,
      type: 'progress',
      // eslint-disable-next-line spellcheck/spell-checker
      icon: 'iconjindutiao',
      defaultInput: 'saas.robotChat.intentDefault.progressInput',
      placeholder: t('saas.robotChat.intentDefault.progressInputPlaceholder'),
      describe: t('saas.robotChat.intentDefault.progressInputDescribe'),
      enabled: true
    },
    {
      text: `${t('saas.robotChat.dataQuery')}`,
      type: 'sql_query',
      // eslint-disable-next-line spellcheck/spell-checker
      icon: 'iconicon_chakan',
      defaultInput: 'saas.robotChat.intentDefault.dataQuery',
      placeholder: t('saas.robotChat.intent.dataQuery.placeholder'),
      describe: t('saas.robotChat.intent.dataQuery.describe'),
      enabled: dataQueriesSwitch
    }, {
      text: `${t('saas.robotChat.risk')}`,
      type: 'risk',
      // eslint-disable-next-line spellcheck/spell-checker
      icon: 'iconfengxianguanli1',
      defaultInput: 'saas.robotChat.intentDefault.risk',
      placeholder: t('saas.robotChat.intent.risk.placeholder'),
      describe: t('saas.robotChat.intent.risk.describe'),
      enabled: false
    }].filter(r => r.enabled) as IntentTypeInputConfig[];
  });
  
  function getIntentInfo(intent: string): IntentTypeInputConfig | undefined {
    if (['weekly_report', 'daily_report'].includes(intent)) {
      intent = 'work_report'; 
    } else if (intent === 'sql_query') {
      intent = 'knowledge_qa';
    }
    return intentTypes.value.find(i => i.type === intent);
  }
  return {
    intentTypes,
    getIntentInfo
  };
};
